import type { Field, FieldValue, Step, VisibilityRule } from '../types/generator-config';

export type Answers = Record<string, FieldValue>;

/**
 * Évalue une règle de visibilité contre les réponses courantes.
 * Retourne `true` si le field/step doit être affiché.
 */
export function evalVisibility(rule: VisibilityRule | undefined, answers: Answers): boolean {
    if (!rule) return true;
    const value = answers[rule.fieldId];

    if (rule.equals !== undefined) return compareEquals(value, rule.equals);
    if (rule.notEquals !== undefined) return !compareEquals(value, rule.notEquals);
    if (rule.in !== undefined) return rule.in.some((v) => compareEquals(value, v));
    if (rule.notIn !== undefined) return !rule.notIn.some((v) => compareEquals(value, v));
    if (rule.includes !== undefined) {
        if (Array.isArray(value)) return value.includes(rule.includes);
        return value === rule.includes;
    }

    // Règle sans condition explicite → toujours visible
    return true;
}

function compareEquals(a: FieldValue, b: string | number): boolean {
    if (a === null || a === undefined) return false;
    if (Array.isArray(a)) return a.includes(String(b)) || a.includes(b as never);
    // Comparaison laxe (l'option peut être '1' et la règle 1)
    return String(a) === String(b);
}

/** Filtre les fields visibles d'une étape */
export function visibleFields(fields: Field[], answers: Answers): Field[] {
    return fields.filter((f) => evalVisibility(f.visibility, answers));
}

/** Filtre les étapes visibles */
export function visibleSteps(steps: Step[], answers: Answers): Step[] {
    return steps.filter((s) => evalVisibility(s.visibility, answers));
}
